// extracted by mini-css-extract-plugin
export default {"page":"page___MLYd","button":"button__KNMvm","tertiary":"tertiary__2Hxff"};